import React from 'react';
import { Switch, SwitchProps, FormControlLabel } from '@mui/material';

interface Props extends SwitchProps {
  label?: React.ReactNode;
  dataTestId?: string;
}

export const FormSwitch = ({ label, dataTestId, ...switchProps }: Props) => {
  return (
    <FormControlLabel
      style={{ whiteSpace: 'nowrap', marginLeft: '0px' }}
      control={
        <Switch
          color="primary"
          {...switchProps}
          inputProps={
            {
              ...switchProps.inputProps,
              ...(dataTestId ? { data_test_id: dataTestId } : {}),
            } as any
          }
        />
      }
      label={label}
    />
  );
};
